import * as React from 'react';

import { Col, Row } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $allFileTemplates,
  $savedTemplateIds,
  $selectedTemplateType,
  $selectTemplateType,
  TEMPLATE_CATEGORIES,
} from '../../../_state/locationDocumentTemplate.state';
import { SettingsContent } from '../../_shared/SettingsContent';

import { TemplateFileViewer } from './TemplateFileViewer';
import { TemplateTypeCard } from './TemplateTypeCard';

export const LocationDocumentTemplates = () => {
  const selectedTemplateType = useAtomValue($selectedTemplateType);
  const savedTemplateIds = useAtomValue($savedTemplateIds);
  const allFileTemplates = useAtomValue($allFileTemplates);
  const selectTemplateType = useSetAtom($selectTemplateType);

  const templateDescriptionByType = React.useMemo(() => {
    const result: Record<string, string | undefined> = {};
    for (const cat of TEMPLATE_CATEGORIES) {
      for (const option of cat.types) {
        const savedId = savedTemplateIds[option.key];
        const template = allFileTemplates.data?.find((t) => t.id === savedId);
        result[option.key] = template?.description ?? undefined;
      }
    }
    return result;
  }, [savedTemplateIds, allFileTemplates.data]);

  return (
    <SettingsContent className="@LocationDocumentTemplates h-full">
      <Row className="h-full gap-4" yStretch>
        <Col className="no-scrollbar h-full w-[240px] shrink-0 gap-px overflow-y-auto p-5 pr-0">
          {TEMPLATE_CATEGORIES.map((cat) => (
            <Col key={cat.category} className="gap-px">
              <div className="px-3 pt-3 pb-1 text-xs font-semibold text-foreground/50 uppercase">
                {cat.category}
              </div>
              {cat.types.map((option) => (
                <TemplateTypeCard
                  key={option.key}
                  label={option.label}
                  sublabel={templateDescriptionByType[option.key]}
                  isSelected={selectedTemplateType === option.key}
                  onClick={() => selectTemplateType(option.key)}
                />
              ))}
            </Col>
          ))}
        </Col>
        <TemplateFileViewer />
      </Row>
    </SettingsContent>
  );
};
